import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Swipe  from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { insuranceLogo } from '../../../config';
import './index.css'
import {  Autoplay,Pagination} from 'swiper/modules'; // Import Autoplay module from Swiper

const InsurancePartners = () => {
  
  const partners = [
    { name: 'Aid by GreenShield', logo: insuranceLogo.equitableLogo },
    { name: 'Canada Life', logo: insuranceLogo.equitableLogo  },
    { name: 'CINUP', logo: insuranceLogo.equitableLogo  },
    { name: 'Coughlin & Associates', logo: insuranceLogo.equitableLogo  },
    { name: 'Chambers of Commerce Group Insurance Plan', logo: insuranceLogo.equitableLogo },
    { name: 'Equitable Life of Canada', logo: insuranceLogo.equitableLogo },
    { name: 'Aid by GreenShield', logo: insuranceLogo.equitableLogo },
    { name: 'Canada Life', logo: insuranceLogo.equitableLogo  },
    { name: 'CINUP', logo: insuranceLogo.equitableLogo  },
    { name: 'Coughlin & Associates', logo: insuranceLogo.equitableLogo  },
    { name: 'Chambers of Commerce Group Insurance Plan', logo: insuranceLogo.equitableLogo },
    { name: 'Equitable Life of Canada', logo: insuranceLogo.equitableLogo }
  ];

  return (
    <div className="bg-white py-10">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl text-primary font-bold text-center mb-6">Insurance Partners</h2>
        <p className="text-center text-gray-600 mb-4">We direct bill to most major insurance companies. Check with our staff if your insurance company is included on the list.</p>
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={6}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            320: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
            1440: {
              slidesPerView: 6,
            },
          }}
        >
          {partners.map((partner, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col items-center py-10">
                <img src={partner.logo} alt={partner.name} className="mb-4 w-24 md:w-32" />
                <p className="text-sm text-gray-500">{partner.name}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default InsurancePartners;